import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    referencias: [],
    referencia: [],
    codigoreferencia:''


  },
  mutations: {
    LoadProductos(state, buscar) {
      //let aux = [];
      state.referencia = state.referencias;


      let aux = state.referencias.filter((x) => x["nombrereferencia"].toUpperCase().includes(buscar.toUpperCase()),);

      if (buscar == "") {
        state.referencia= state.referencias;
      } else {
        state.referencia = aux;

      }
    },



    async cargardatosreferencias(state) {

      state.referencias = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/referencias", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.referencias = response.data.data;
         

        });
      state.referencia = state.referencias
    },

    cambio(state, descripcion) {
      state.descripcionmodal = descripcion.descripcion
      state.codigoreferencia = descripcion.codigoreferencia

    },
    agregartable(state) {

      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombrereferencia: state.descripcionmodal,
        codigoreferencia: state.codigoreferencia
      };
      this.banderamodal = store.state.banderamodal



      var datosfalso = state.idmodal;

      if (this.banderamodal === true) {


        axios

          .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/referencias", datos, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;


          })

          .catch((e) => {
            console.log(e);
          });
      } else {

        axios

          .post(
            "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/referencias/UpdateReg/" +
            datosfalso,
            datos,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;

          })

          .catch((e) => {
            console.log(e);
          });
      }

    },


    datosmodal(state, api) {

      state.idmodal = api.idreferencia,
        state.descripcionmodal = api.nombrereferencia,
        state.codigoreferencia = api.codigoreferencia
       
    },



    async eliminar(state, api) {
      var token = store.state.numero
      let eliminar = api;


      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/referencias/DeleteReg/" + eliminar,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })


        .then((response) => {
          let tokenn = response.data.token;
          state.datoeliminar = tokenn

        })

        .catch((e) => {
          console.log(e);
        });



    },



  },
  actions: {

  },
  getters: {


  },






}